"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
var _NotFound = _interopRequireDefault(require("../../../components/NotFound.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default = exports.default = {
  name: 'PowerBIEmbed',
  components: {
    NotFound: _NotFound.default
  },
  props: {
    digitalAsset: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      loading: false,
      link: '',
      token: '',
      reportSuccess: true,
      window: {
        width: '100%',
        height: '100%'
      },
      config: {
        type: 'report',
        settings: {
          panes: {
            filters: {
              visible: false
            },
            pageNavigation: {
              visible: true
            }
          }
        }
      }
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['analiticParams'])),
  watch: {
    digitalAsset: {
      immediate: true,
      handler: function handler(newValue) {
        if (newValue) {
          this.getEmbeddedParams();
        }
      }
    }
  },
  created: function created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['fetchURLEmbeddedAnalytic', 'fetchReportIdService'])), {}, {
    embeddedSetting: function embeddedSetting(ts) {
      // Função de configuração personalizada, se necessário
    },
    handleResize: function handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    // Função utilitária para delay
    delay: function delay(ms) {
      return new Promise(function (resolve) {
        return setTimeout(resolve, ms);
      });
    },
    getEmbeddedParams: function () {
      var _getEmbeddedParams = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var reportParams, loadingComponent, BIParams;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.n = 1;
              return this.fetchReportIdService(this.digitalAsset);
            case 1:
              reportParams = _context.v;
              if (!(reportParams === 'report_not_exist')) {
                _context.n = 2;
                break;
              }
              this.reportSuccess = false;
              return _context.a(2);
            case 2:
              this.link = "https://app.powerbi.com/reportEmbed?reportId=".concat(reportParams.reportId, "&ctid=").concat(reportParams.ctid);
              loadingComponent = this.$buefy.loading.open({
                container: null
              });
              _context.p = 3;
              _context.n = 4;
              return this.fetchURLEmbeddedAnalytic({
                reportId: reportParams.reportId
              });
            case 4:
              BIParams = _context.v;
              this.token = BIParams.token;

              // Adicionar delay para garantir que o DOM esteja pronto
              _context.n = 5;
              return this.delay(500);
            case 5:
              _context.n = 6;
              return this.renderEmbedded(BIParams);
            case 6:
              _context.p = 6;
              loadingComponent.close();
              return _context.f(6);
            case 7:
              return _context.a(2);
          }
        }, _callee, this, [[3,, 6, 7]]);
      }));
      function getEmbeddedParams() {
        return _getEmbeddedParams.apply(this, arguments);
      }
      return getEmbeddedParams;
    }(),
    renderEmbedded: function renderEmbedded(params) {
      var reportDiv = document.getElementById('reportContainer');
      this.config = _objectSpread(_objectSpread({}, this.config), {}, {
        embedUrl: this.link,
        accessToken: this.token,
        id: params.reportId,
        filters: [{
          $schema: 'http://powerbi.com/product/schema#basic',
          target: {
            table: 'relacional Vw_Score_Volumetria_Quantitativossss',
            column: 'ame_consumer_id'
          },
          operator: 'In',
          values: ['HIVEP01'] // Valor do filtro
        }]
      });

      // eslint-disable-next-line no-undef
      powerbi.embed(reportDiv, this.config);
    }
  })
};